import Vue from "vue";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { email, numeric, required, min_value, } from "vee-validate/dist/rules";

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
import {
  REQUIRED,
  EMAIL_INVALID,
  NUMERIC,
  MAX_LENGTH
} from "@/constants/validateMessages";

extend("required", {
  ...required,
  message: REQUIRED
});
extend("email", {
  ...email,
  message: EMAIL_INVALID
});
extend("numeric", {
  ...numeric,
  message: NUMERIC
});
extend("positive_number", {
  ...min_value,
  message: "Không được phép nhập giá trị âm"
});

extend("minmax", {
  validate(value, { min, max }) {
    if (value) {
      return value.toString().length >= min && value.toString().length <= max;
    } else {
      return true;
    }
  },
  params: ["min", "max"],
  message: `Giá trị không được nhỏ hơn {min} và vượt quá {max} ký tự`
});


extend("maxlength", {
  validate(value, { maxlength }) {
    if (value) {
      return value.replace(/<\/?[^>]+(>|$)/g, "").toString().length <= maxlength;
    } else {
      return true;
    }
  },
  params: ["maxlength"],
  message: `${MAX_LENGTH} {maxlength} ký tự`
});

extend("maxNumber", {
  validate(value){
    const length = value;
    if(length > 0 && length <= 100){
      return true;
    }
  },
  message : `Giá trị lớn hơn 0 và nhỏ hơn hoặc bằng 100`,
});

extend("cmtnd", {
  validate(value) {
    const length = value.length;
    if (length === 9 || length === 12) {
      return true;
    }
    return false;
  },
  message: `Số CMTND là dãy số dài 9 hoặc 12 ký tự`
});
extend("sdt", {
  validate(value) {
    let length = value.length;
    if (length >= 10 && length <= 15) {
      return true;
    }
    return false;
  },
  message: `Là số và có độ dài 10-15 kí tự `
});

extend("noscript", {
  validate(value) {
    const regex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    const regexhtml = /<([a-zA-Z]+)(?![^>]*\/>)[^>]*>/g
    const found = value.match(regex) || value.match(regexhtml);
    return found === null
  },
  message: `Nội dung không được chứa các thẻ script, html`
});
